import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { StyleSheetManager } from "styled-components";
import rtlPlugin from "stylis-plugin-rtl";
import { BrowserRouter } from "react-router-dom";

import configureStore from "./store";
import StyleProvider from "./theme/StyleProvider";

import App from "./App";

import "./assets/scss/index.scss";
import history from "./router/history";

const store = configureStore().store;

ReactDOM.render(
  <Provider store={store}>
    <BrowserRouter history={history}>
      <StyleSheetManager stylisPlugins={[rtlPlugin]}>
        <StyleProvider>
          <App />
        </StyleProvider>
      </StyleSheetManager>
    </BrowserRouter>
  </Provider>,
  document.getElementById("root")
);
